module.exports = __webpack_public_path__ + "media/suit_analysis_mobile.165a39fb.mp4";